module.exports = __webpack_public_path__ + "img/otherLogo.aa4c83cb.svg";